import React from 'react';
import CountUp from 'react-countup';

interface StatItem {
  value: number;
  label: string;
  color: string;
}

interface StatsSectionProps {
  stats?: StatItem[];
  darkMode: boolean;
}

export const StatsSection: React.FC<StatsSectionProps> = ({ 
  stats = [
    { value: 20, label: 'Specialized Personas', color: 'blue' },
    { value: 15, label: 'Workflow Templates', color: 'purple' },
    { value: 100, label: 'Customizable', color: 'amber' },
    { value: 99, label: 'Satisfaction Rate', color: 'green' }
  ],
  darkMode 
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 my-16">
      {stats.map((stat, index) => (
        <div 
          key={index} 
          className={`${darkMode ? 'bg-gray-800' : 'bg-white'} p-6 rounded-lg shadow-md text-center`}
        >
          <div className={`text-3xl font-bold ${darkMode ? `text-${stat.color}-400` : `text-${stat.color}-600`}`}>
            <CountUp end={stat.value} duration={2.5} />
            {stat.value === 100 ? '%' : '+'}
          </div>
          <div className={`text-sm mt-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{stat.label}</div>
        </div>
      ))}
    </div>
  );
};
